import * as PIXI from "pixi.js";
import MyApplication from "../../../pixi/MyApplication";
import AssetsManager from "../../../pixi/AssetsManager";
import PandaView from "./PandaView";
import MathUtil from "../../../util/MathUtil";

const RATES: Array<number> = [1, 8, 1, 60, 8, 2, 30, 1, 1, 2, 60];

/**
 * ObstacleViewクラス
 */
class ObstacleView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //ムービークリップ
  private _mc: PIXI.AnimatedSprite;

  // ---------------------------------------------------------------------------------------------------------
  // --	ObstacleView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(landIndex: number) {
    super();

    //種類
    const kind: number = Math.floor(Math.random() * 10) + 1;

    //ラベル
    const mcLabel: string = kind >= 10 ? "objB" : "obj";

    //ムービークリップ生成
    this._mc = AssetsManager.instance.createMovieClipFromAnimation(
      mcLabel + kind,
      false
    );
    this._mc.scale.set(4);
    this._mc.x = -this._mc.width / 2;
    this._mc.y = -this._mc.height + 40;
    this._mc.animationSpeed = RATES[kind] / 60;
    this._mc.play();
    this.addChild(this._mc);

    //初期位置
    this.y = (259 + 70 * landIndex) * 2;
    this.x = MyApplication.screenWidth + this._mc.width;

    //zIndex
    this.zIndex = this.y;
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	ACTION
  // ---------------------------------------------------------------------------------------------------------

  /**
   * アップデート
   */
  public update(speed: number): void {
    //移動
    this.x -= speed;
  }

  /**
   * パンダとのヒットテスト
   */
  public hitTestPanda(panda: PandaView): boolean {
    //距離
    var distance: number = MathUtil.getDistance(this.position, panda.position);

    //当たり
    if (distance <= 40 && panda.x <= this.x) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 破棄
   */
  public destroy(): void {
    //アニメーション停止
    this._mc.stop();

    //リムーブ
    super.destroy();
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ObstacleView;
